
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';
import { HomeController } from '@mainrepo/app/core/controller/HomeController';
import { PreLoginSharedViewController } from '@sharerepo/app/core/controller/PreloginSharedViewController';
import { UnivShareLinkAllFilesController } from '@sharerepo/app/core/controller/UnivShareLinkAllFilesController';
import { FoldersViewImplementation } from '../implementation/FoldersViewImplementation';
import { GlobalService } from '../services/global.service';
import { Controller } from './Controller';

export class FoldersViewController extends Controller{
  public folderViewImplementation: any;
  public universalService: any;
  public static singleInstance: any = null;
  public listService:any;
    homeController: any;
    allFilesController: any;
    preLoginController:any;
  univShareController: UnivShareLinkAllFilesController;
  recalculateHeightService:any;

  public constructor(public globalService:GlobalService) {
    super(globalService)
    this.folderViewImplementation = FoldersViewImplementation.getInstance(globalService);
    this.setEnvObjects(globalService);
  }

  public static getInstance(globalService): FoldersViewController {
    if (this.singleInstance == null) {
      this.singleInstance = new FoldersViewController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
    if(this.universalService.activeRepo == 'share'){
        this.preLoginController = PreLoginSharedViewController.getInstance(this.globalService);
        this.univShareController = UnivShareLinkAllFilesController.getInstance(this.globalService);
    }else{
      this.allFilesController = AllFilesController.getInstance(this.globalService);
      this.homeController = HomeController.getInstance(this.globalService);
    }
    
  }


  async openFolderContent(folderObjectKey,folderObjectName,folderObject){
    this.folderViewImplementation.setHandler(this.globalService);
    var result = await this.folderViewImplementation.openFolderContent(folderObjectKey, folderObjectName,folderObject);
    if(this.universalService.activeRepo == 'main'){
      this.homeController.setEnvObjects(this.globalService);
      this.allFilesController.setEnvObjects(this.globalService);
      this.universalService.selectedNodes = [];

    }
    else if(window.location.href.includes('?u')){
      this.univShareController.openFolderContent(folderObject);
      this.universalService.viewIsTabOriented = true;
      this.universalService.emptyTabViewRequiresMenu = true;
    }
    else{
      this.preLoginController.setEnvObjects(this.globalService);
      this.preLoginController.openFolder(folderObject);
      this.preLoginController.getFiles()
    }
    this.recalculateHeightService.sendRecalculateEventToComponents(true);
    // this.allFilesController.getAllFiles();
  }
}
